import type { ReactNode } from 'react';

interface RenonciationRetractationProps {
    acceptee: boolean;
    onChange: (acceptee: boolean) => void;
}

/**
 * Renonciation au droit de rétractation (art. L221-28 13° du Code de la
 * consommation) : sans elle, aucun paiement ne part. Le serveur exige
 * `withdrawalWaiverAccepted: true` et en garde la trace.
 */
export function RenonciationRetractation({ acceptee, onChange }: RenonciationRetractationProps): ReactNode {
    return (
        <label className="flex items-start gap-2 mb-4 p-3 bg-[#FFFBEB] border border-[#FDE68A] rounded-lg cursor-pointer">
            <input
                type="checkbox"
                checked={acceptee}
                onChange={(e) => onChange(e.target.checked)}
                className="mt-0.5 h-4 w-4 rounded border-[#FDE68A] text-[#0F2744] focus:ring-[#0F2744] shrink-0"
            />
            <span className="text-xs text-[#78350F] dark:text-[#FDE68A] leading-relaxed">
                J'accepte que le service démarre immédiatement après la souscription et je reconnais
                renoncer expressément à mon droit de rétractation de 14 jours
                (art. L.221-28 13° du Code de la consommation).
                Voir les <a href="/cgu" target="_blank" rel="noopener noreferrer" className="underline font-semibold hover:text-[#0F2744] dark:hover:text-[#FCD34D]">CGU</a>.
            </span>
        </label>
    );
}
